import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);


if (document.querySelector(".hero-svg-overlap"))  {

let heroSvgOverlap = '.hero-svg-overlap'
let	heroSvgImgs = '.hero-svg-overlap  img'
let	heroSvgHeadlines = '.hero-svg-overlap h1'
let heroSvg = '.hero-svg-overlap--right-svg > svg'
let heroSvgLines = '.hero-svg-overlap--right-svg path'
let heroSvgPlace = '.hero-svg-overlap--right-svg .ackern__place'

let heroSvgIntro = '.bg-color-transition-start--hero'
let heroSvgTl = gsap.timeline()


heroSvgTl
	.from(heroSvgImgs, {duration: 1, opacity: 0, x: -200, stagger: 0.5})
	.from(heroSvgLines, {scale: 0, stagger: 0.1}, "=-1")
	.from(heroSvgPlace, {duration: 2, opacity: 0, y: -50, ease: "elastic.out"})
	.from(heroSvgIntro, {duration: 1, opacity: 0}, "=-1");
}

if (document.querySelector(".bg-img-half--img"))  {
ScrollTrigger.matchMedia({
"(min-width: 1025px)": function() {

let symbioseImgLeft = '.bg-img-half--img'
let	symbioseImgRight = '.symbiose__hero img'
let	symbioseText = '.symbiose__hero h1, .symbiose__hero p'
let symbioseHero = 'symbiose__hero'
let symbioseHeroTl = gsap.timeline()

symbioseHeroTl
	.from(symbioseImgLeft, {duration: 2, opacity: 0, height: -50, transformOrigin: "top"})
	.from(symbioseText, {duration: 1, opacity: 0, x: 100, stagger: 0.25}, "=-.5")
	.from(symbioseImgRight, {duration: 1, opacity: 0, x: 100},"=-.5")

}
});
}
